import React, { useEffect } from "react";
import Typed from "typed.js";
import { Portfolio } from "../../../../../graphql/generated";
import { HomeInfo, HomeSectionWrapper } from "./styled";

interface Props {
  portfolioData: Omit<Portfolio, "createdBy">;
}

const HomeSection: React.FC<Props> = ({ portfolioData }) => {
  useEffect(() => {
    if (portfolioData.knownAs) {
      const typed = new Typed(".element", {
        strings: portfolioData?.knownAs.map((item) => item + ".") || [
          "Web Developer.",
          "Web Designer.",
          "Freelancer.",
        ],
        typeSpeed: 60,
        loop: true,
        backSpeed: 30,
        smartBackspace: true,
      });

      return () => typed.destroy();
    }
  }, [portfolioData]);

  return (
    <HomeSectionWrapper>
      <HomeInfo>
        <h1>{portfolioData?.for || "Mehedi Hassan Shifat"}</h1>
        <p>
          I am a{" "}
          <span
            style={{
              textTransform: "capitalize",
            }}
            className="element"
          />
        </p>
      </HomeInfo>
    </HomeSectionWrapper>
  );
};

export default HomeSection;
